#!/usr/bin/env node
import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireTailwindTranspiler } from "F:\\project\\Tailwind-Transpiler\\index.js";
var TailwindTranspilerExports = requireTailwindTranspiler();
export { TailwindTranspilerExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(TailwindTranspilerExports);